export const ShopCreditCardBusinessRoutes = {
    ROOT: "/shop-credit-card-business",
    PERSONAL_DATA: "/shop-credit-card-business/personal-data",
    CARD_INFO: "/shop-credit-card-business/card-info",
    NEW_PHONE: "/shop-credit-card-business/new-phone",
    NEW_ADDRESS: "/shop-credit-card-business/new-address",
    SUMMARY: "/shop-credit-card-business/summary",
    SIGNING: "/shop-credit-card-business/signing",
    SUCCESS: "/shop-credit-card-business/success"
};


// WEBPACK FOOTER //
// ./src/components/shopCreditCardBusiness/ShopCreditCardBusinessRoutes.ts